import React from 'react';
import './styles.scss';

class Services extends React.Component {
	render() {
		return (
			<main className="main services">
				<h1>Servicios</h1>
			</main>
		)
	}
};

export default Services;